import type { FullTranslation } from "../lib/i18n"

export const CASE_STUDIES_T = {
  metaTitle: {
    FR: "Cas clients : prospection B2B métier par métier",
    EN: "Case studies: B2B prospecting, trade by trade",
  },
  metaDescription: {
    FR: "Comment chaque marché se prospecte vraiment : structure du secteur, où trouvent les contacts, ce qui marche. Campagnes réelles, clients anonymisés.",
    EN: "How each market is really prospected: how the trade is structured, where the contacts sit, what lands. Real campaigns, clients anonymised.",
  },
  badge: { FR: "Cas clients", EN: "Case studies" },
  heading1: {
    FR: "Comment on prospecte vraiment un marché avec",
    EN: "How a market actually gets prospected with",
  },
  subhead: {
    FR: "Des campagnes réelles, décortiquées métier par métier : qui sont ces entreprises, où se cachent les contacts, et ce qui fait décrocher.",
    EN: "Real campaigns, taken apart trade by trade: who these businesses are, where the contacts hide, and what gets a reply.",
  },
  title: { FR: "Cas clients", EN: "Case studies" },
  subtitle: {
    FR: "campagnes réelles, décortiquées métier par métier.",
    EN: "real campaigns, taken apart trade by trade.",
  },
  empty: {
    FR: "Aucun cas client pour le moment.",
    EN: "No case study yet.",
  },
  leads: { FR: "leads", EN: "leads" },
  emails: { FR: "E-mails", EN: "Emails" },
  phones: { FR: "Téléphones", EN: "Phones" },
  view: { FR: "Voir", EN: "View" },
  loadingMap: { FR: "Chargement de la carte…", EN: "Loading map…" },
} satisfies FullTranslation
